import { Directive } from '@angular/core';

@Directive({
    selector: 'li[facet-links]',
    host: {
        '[class.b-navigation__shortcut-item]': 'true'
    },
    standalone: false
})
export class FacetLinksDirective {}
